import { ZINDEX_USAGES } from '@app/domains/common/constants/zindex';
import styles from '@app/domains/common/hooks/styles.module.scss';
import clsx from 'clsx';

export default function Toast({ callback, transitionRef, fadeoutDuration, text }) {
    return (
        <div ref={callback}>
            <section
                className={clsx('fixed bottom-0 mb-16 w-screen translate-y-20 p-20 transition', styles['slide-up'])}
                style={{ zIndex: ZINDEX_USAGES.TOAST, animationDuration: `${fadeoutDuration}ms` }}
                ref={transitionRef}
            >
                <div className="flex justify-center">
                    <div className="font-set-sb14 rounded-full bg-black/70 py-12 px-16 text-white">{text}</div>
                </div>
            </section>
        </div>
    );
}
